import addStudentInTeacher from '../../assets/img/add-student-in-teacher.svg';
import addSubjectIcon from '../../assets/img/add-subject-icon.svg';
import checksIcon from '../../assets/img/checks-notification-icon.svg';
import checksNotIcon from '../../assets/img/checks-one-notification-icon.svg';
import exumIcon from '../../assets/img/exum-notification-icon.svg';
import materialIcon from '../../assets/img/material-notification-icon.svg';
import notebookIcon from '../../assets/img/notebook-notification-icon.svg';
import subjectTeacherIcon from '../../assets/img/subject-teacher-Icon.svg';

export const renderNotificationItem = (
  item,
  t,
  language,
  handleNavigationItem,
  student,
  subjectsObjKey,
  findStudent,
  formatDate,
  buildUrl,
  navigate,
) => {
  let studentName;

  const teacherName = item.name;

  const isExam = item.workType === 'exam';
  const typeOfCheckedWork = isExam ? 'exam name' : 'checkLists';

  const routePathStudent = isExam ? '/exam-student' : '/checklist-student';
  const routePathTeacher = isExam ? '/exam-teacher-new' : '/checklist-teacher-new';

  const studentTeacher = findStudent(item.mail);

  const currentStudent = student === undefined ? studentTeacher : student;

  if (studentTeacher && studentTeacher.hasOwnProperty('FIO')) {
    studentName = studentTeacher.FIO;
  } else {
    studentName = item.name;
  }

  const handleMouseDown = (e, item) => {
    e.preventDefault();
    const url = buildUrl(item);
    window.open(url, '_blank');
  };

  const getMessage = (baseMessage, linkText, subject) => (
    <div className="notification-item-content" style={{ alignItems: 'center' }}>
      <div className="left-block">
        {item.type === 'materials' && (
          <span className="icon">
            <img src={materialIcon} alt="icon" />
          </span>
        )}

        {item.type === 'materials interative-exum' ||
          (item.type === 'iclToStudent' && (
            <span className="icon">
              <img src={exumIcon} alt="icon" />
            </span>
          ))}

        {item.type === 'hwToStudent' && (
          <span className="icon">
            <img src={exumIcon} alt="icon" />
          </span>
        )}

        {(item.type === 'examToStudent' || item.type === 'examCompleted' || item.type === 'examChecked') && (
          <span className="icon">
            <img src={exumIcon} alt="icon" />
          </span>
        )}

        {(item.type === 'notebook' ||
          item.type === 'comment' ||
          item.type === 'commentHw' ||
          item.type === 'taskChecked' ||
          item.type === 'taskCompleted' ||
          item.type === 'taskCompletedHw' ||
          item.type === 'taskCheckedHw') && (
          <span className="icon">
            <img src={notebookIcon} alt="icon" />
          </span>
        )}
      </div>
      <div className="right-block">
        <span className="text-row">
          {item.type !== 'taskChecked' &&
            item.type !== 'taskCompleted' &&
            item.type !== 'taskCompletedHw' &&
            item.type !== 'taskCheckedHw' &&
            t(baseMessage) + ' '}
          {(item.type === 'taskChecked' || item.type === 'taskCheckedHw') &&
            `${t('Teacher')} ${item.name} ${t('check')} ${t('point')} "${item.taskText}" ${t('checked your work in')} `}
          {(item.type === 'taskCompleted' || item.type === 'taskCompletedHw') &&
            `${t('Student')} ${item.name} ${t('check')} ${t('point')} "${item.taskText}" ${item.complete ? t('completed your work in') : t('no completed your work in')} `}
          <span
            className="cursor-pointer text-[#52c7fa]"
            onClick={e => {
              if (item.type === 'comment' || item.type === 'iclToStudent' || item.type === 'taskChecked') {
                navigate(routePathStudent, { state: { checkListId: item.iclId } });
              }

              if (item.type === 'examToStudent') {
                navigate('/exam-student', { state: { examId: item.iclId } });
              }
              if (item.type === 'commentHw' || item.type === 'hwToStudent' || item.type === 'taskCheckedHw') {
                navigate('/hw-student', { state: { hwId: item.iclId } });
              }

              if (item.type === 'examCompleted') {
                navigate('/exam-teacher-new', {
                  state: { examId: item.iclId },
                });
              }

              if (item.type === 'examChecked') {
                navigate('/exam-student', {
                  state: { examId: item.iclId },
                });
              }

              if (item.type === 'taskCompleted' || item.type === 'examCompleted') {
                navigate(routePathTeacher, {
                  state: isExam
                    ? { examId: item.iclId, taskId: item.taskId }
                    : { checkListId: item.iclId, taskId: item.taskId },
                });
              }
              if (item.type === 'taskCompletedHw') {
                navigate('/hw-teacher', { state: { hwId: item.iclId } });
              } else {
                handleNavigationItem(e, item);
              }
            }}
            onMouseDown={e => {
              item.type !== 'comment' &&
                item.type !== 'iclToStudent' &&
                item.type !== 'examToStudent' &&
                item.type !== 'taskChecked' &&
                item.type !== 'taskCompleted' &&
                item.type !== 'taskCheckedHw' &&
                item.type !== 'taskCompletedHw' &&
                item.type !== 'commentHw' &&
                item.type !== 'hwToStudent' &&
                item.type !== 'materials' &&
                item.subType !== 'Book' &&
                item.type !== 'examChecked' &&
                item.type !== 'examCompleted' &&
                handleMouseDown(e, item);
            }}
          >
            {t(linkText)}
          </span>

          {item.type !== 'comment' &&
            item.type !== 'iclToStudent' &&
            item.type !== 'examToStudent' &&
            item.type !== 'taskChecked' &&
            item.type !== 'taskCompleted' &&
            item.type !== 'taskCompletedHw' &&
            item.type !== 'hwToStudent' && (
              <>
                {' ' + t('by subject') + ' '}
                {subject}.
              </>
            )}

          {(item.type === 'iclToStudent' ||
            item.type === 'examToStudent' ||
            item.type === 'taskChecked' ||
            item.type === 'taskCompleted' ||
            item.type === 'taskCompletedHw' ||
            item.type === 'hwToStudent') && (
            <>
              {' ' + t('by subject') + ' '}
              {language === 'ua' ? item.subject.name : item.subject.ruName}.
            </>
          )}
        </span>
        <span className="icon">
          <img src={item.viewed ? checksNotIcon : checksIcon} alt="icon" />
        </span>
        <span className="time-row">{formatDate(item.time)}</span>
      </div>
    </div>
  );

  switch (item.type) {
    case 'materials interative-exum':
      return getMessage('They sent you a new one', 'Check Sheet', t(currentStudent?.materials[item.idItem]?.subject));

    case 'materials':
      if (item.subType === 'Book') {
        return getMessage('They sent you a new one', 'material', t(currentStudent?.materials[item.idItem]?.subject));
      } else if (item.subType === 'Exam') {
        return getMessage('They sent you a new one', 'material', t(currentStudent?.materials[item.idItem]?.subject));
      }
      break;

    case 'notebook':
      return getMessage('The teacher checked your work in', 'from a notebook', t(subjectsObjKey[item.subject]));

    case 'comment':
      return getMessage('The teacher posted a comment in', typeOfCheckedWork);

    case 'commentHw':
      return getMessage('The teacher posted a comment in', 'Homework hm');

    case 'iclToStudent':
      return getMessage('The teacher sent you a new one', typeOfCheckedWork, t(subjectsObjKey[item.subject]));

    case 'examToStudent':
      return getMessage('The teacher sent you a new one', 'exam name', t(subjectsObjKey[item.subject]));

    case 'taskChecked':
      return getMessage('The teacher checked your work in', typeOfCheckedWork, t(subjectsObjKey[item.subject]));

    case 'taskCompleted':
      return getMessage('The teacher checked your work in', typeOfCheckedWork, t(subjectsObjKey[item.subject]));
    case 'taskCompletedHw':
      return getMessage('The teacher checked your work in', 'Homework hm', t(subjectsObjKey[item.subject]));
    case 'taskCheckedHw':
      return getMessage('The teacher checked your work in', 'Homework hm', t(subjectsObjKey[item.subject]));
    case 'hwToStudent':
      return getMessage('They sent you a new one hm', 'Homework hm', t(subjectsObjKey[item.subject]));

    case 'subjects':
      return (
        <div className="notification-item-content">
          <div className="left-block">
            <span className="icon">
              <img src={addSubjectIcon} alt="icon" />
            </span>
          </div>
          <div className="right-block">
            <span className="text-row">
              {t('They add you a new one subject') + ' '}
              {t(subjectsObjKey[item.subject])}
            </span>
            <span className="icon">
              <img src={item.viewed ? checksNotIcon : checksIcon} alt="icon" />
            </span>
            <span className="time-row">{formatDate(item.time)}</span>
          </div>
        </div>
      );

    case 'subjects-remove':
      return (
        <div className="notification-item-content">
          <div className="left-block">
            <span className="icon">
              <img src={addSubjectIcon} alt="icon" />
            </span>
          </div>
          <div className="right-block">
            <span className="text-row">{`${t('removed subject for you')} ${t(subjectsObjKey[item.subject])}`}</span>
            <span className="icon">
              <img src={item.viewed ? checksNotIcon : checksIcon} alt="icon" />
            </span>
            <span className="time-row">{formatDate(item.time)}</span>
          </div>
        </div>
      );

    case 'subjects add-teacher':
      return (
        <div className="notification-item-content">
          <div className="left-block">
            <span className="icon">
              <img src={subjectTeacherIcon} alt="icon" />
            </span>
          </div>
          <div className="right-block">
            <span className="text-row">
              {t('You have been assigned a teacher') + ' "' + item.name}
              {'" ' + t('by subject') + ' '}
              {t(subjectsObjKey[item.subject])}.
            </span>
            <span className="icon">
              <img src={item.viewed ? checksNotIcon : checksIcon} alt="icon" />
            </span>
            <span className="time-row">{formatDate(item.time)}</span>
          </div>
        </div>
      );
    case 'subjects add-student':
      return (
        <div className="notification-item-content">
          <div className="left-block">
            <span className="icon">
              <img src={addStudentInTeacher} alt="icon" />
            </span>
          </div>
          <div className="right-block">
            <span className="text-row">
              {t('You have been assigned as a students teacher') + ' "'}
              <a href="#" onClick={e => handleNavigationItem(e, item)} onMouseDown={e => handleMouseDown(e, item)}>
                {item.name}{' '}
              </a>
              {'" ' + t('by subject') + ' '}
              {t(subjectsObjKey[item.subject])}.
            </span>
            <span className="icon">
              <img src={item.viewed ? checksNotIcon : checksIcon} alt="icon" />
            </span>
            <span className="time-row">{formatDate(item.time)}</span>
          </div>
        </div>
      );

    case 'subjects add-group':
      return (
        <div className="notification-item-content">
          <div className="left-block">
            <span className="icon">
              <img src={addStudentInTeacher} alt="icon" />
            </span>
          </div>
          <div className="right-block">
            <span className="text-row">
              {t('You have been assigned as a group teacher') + ' "'}
              <a href="#" onClick={e => handleNavigationItem(e, item)} onMouseDown={e => handleMouseDown(e, item)}>
                {item.name}{' '}
              </a>
              {'" ' + t('by subject') + ' '}
              {t(subjectsObjKey[item.subject])}.
            </span>
            <span className="icon">
              <img src={item.viewed ? checksNotIcon : checksIcon} alt="icon" />
            </span>
            <span className="time-row">{formatDate(item.time)}</span>
          </div>
        </div>
      );

    case 'materials interative-exum setStudentPhoto':
      return (
        <div className="notification-item-content">
          <div className="left-block">
            <span className="icon">
              <img src={exumIcon} alt="icon" />
            </span>
          </div>
          <div className="right-block">
            <span className="text-row">
              {`${t('Student')} ${studentName} ${t('added a photo to')} `}
              <a href="#" onClick={e => handleNavigationItem(e, item)} onMouseDown={e => handleMouseDown(e, item)}>
                {t('Check Sheet photo to')} {'( ' + t('point') + ' №' + item.point + ' )'}
              </a>
              {' ' + t('by subject') + ' '}
              {t(subjectsObjKey[item.subject])}.
            </span>
            <span className="icon">
              <img src={item.viewed ? checksNotIcon : checksIcon} alt="icon" />
            </span>
            <span className="time-row">{formatDate(item.time)}</span>
          </div>
        </div>
      );

    case 'materials interative-exum setItemPointExumChecked':
      return (
        <div className="notification-item-content">
          <div className="left-block">
            <span className="icon">
              <img src={exumIcon} alt="icon" />
            </span>
          </div>
          <div className="right-block">
            <span className="text-row">
              {`${t('Student')} ${studentName} ${t('marked the point')} `}
              <a href="#" onClick={e => handleNavigationItem(e, item)} onMouseDown={e => handleMouseDown(e, item)}>
                {'( ' + t('point') + ' №' + item.point + ' )'}
              </a>
              {` ${t('how its done')} `}
              <a href="#" onClick={e => handleNavigationItem(e, item)} onMouseDown={e => handleMouseDown(e, item)}>
                {t('how its done Check Sheet')}
              </a>
              {' ' + t('by subject') + ' '}
              {t(subjectsObjKey[item.subject])}.
            </span>
            <span className="icon">
              <img src={item.viewed ? checksNotIcon : checksIcon} alt="icon" />
            </span>
            <span className="time-row">{formatDate(item.time)}</span>
          </div>
        </div>
      );
    case 'materials interative-exum setItemNotPointExumChecked':
      return (
        <div className="notification-item-content">
          <div className="left-block">
            <span className="icon">
              <img src={exumIcon} alt="icon" />
            </span>
          </div>
          <div className="right-block">
            <span className="text-row">
              {`${t('Student')} ${studentName} ${t('canceled execution')} `}
              <a href="#" onClick={e => handleNavigationItem(e, item)} onMouseDown={e => handleMouseDown(e, item)}>
                {'( ' + t('point') + ' №' + item.point + ' )'}
              </a>
              {` ${t('in')} `}
              <a href="#" onClick={e => handleNavigationItem(e, item)} onMouseDown={e => handleMouseDown(e, item)}>
                {t('how its done Check Sheet')}
              </a>
              {' ' + t('by subject') + ' '}
              {t(subjectsObjKey[item.subject])}.
            </span>
            <span className="icon">
              <img src={item.viewed ? checksNotIcon : checksIcon} alt="icon" />
            </span>
            <span className="time-row">{formatDate(item.time)}</span>
          </div>
        </div>
      );
    case 'materials interative-exum studentDateStart':
      return (
        <div className="notification-item-content">
          <div className="left-block">
            <span className="icon">
              <img src={exumIcon} alt="icon" />
            </span>
          </div>
          <div className="right-block">
            <span className="text-row">
              {t('The student began to complete the task') + ' '}
              <a href="#" onClick={e => handleNavigationItem(e, item)} onMouseDown={e => handleMouseDown(e, item)}>
                {t('Check Sheet photo to') + ' ( ' + item.name + ' ) '}
              </a>
              {' ' + t('by subject') + ' '}
              {t(subjectsObjKey[item.subject])}.
            </span>
            <span className="icon">
              <img src={item.viewed ? checksNotIcon : checksIcon} alt="icon" />
            </span>
            <span className="time-row">{formatDate(item.time)}</span>
          </div>
        </div>
      );

    case 'materials interative-exum studentDateCompleted':
      return (
        <div className="notification-item-content">
          <div className="left-block">
            <span className="icon">
              <img src={exumIcon} alt="icon" />
            </span>
          </div>
          <div className="right-block">
            <span className="text-row">
              {`${t('Student')} ${studentName} ${t('noted that he had finished his work')} `}
              <a href="#" onClick={e => handleNavigationItem(e, item)} onMouseDown={e => handleMouseDown(e, item)}>
                {t('his work checklist') + ' ( ' + item.name + ' ) '}
              </a>
              {' ' + t('by subject') + ' '}
              {t(subjectsObjKey[item.subject])}.
            </span>
            <span className="icon">
              <img src={item.viewed ? checksNotIcon : checksIcon} alt="icon" />
            </span>
            <span className="time-row">{formatDate(item.time)}</span>
          </div>
        </div>
      );
    case 'homeworks-student homeworks-points setItemPointHomeworkChecked':
      return (
        <div className="notification-item-content">
          <div className="left-block">
            <span className="icon">
              <img src={exumIcon} alt="icon" />
            </span>
          </div>
          <div className="right-block">
            <span className="text-row">
              {/* {t('The student marked the point') + ' '} */}
              {`${t('Student')} ${studentName} ${t('marked the point')} `}
              <a href="#" onClick={e => handleNavigationItem(e, item)} onMouseDown={e => handleMouseDown(e, item)}>
                {'( ' + t('point') + ': ' + item.titles[item.point - 1] + ' )'}
              </a>
              {` ${t('how its done')} `}
              <a href="#" onClick={e => handleNavigationItem(e, item)} onMouseDown={e => handleMouseDown(e, item)}>
                {t('In homework') + ' ( ' + item.name + ' ) '}
              </a>
              {' ' + t('by subject') + ' '}
              {t(subjectsObjKey[item.subject])}.
            </span>
            <span className="icon">
              <img src={item.viewed ? checksNotIcon : checksIcon} alt="icon" />
            </span>
            <span className="time-row">{formatDate(item.time)}</span>
          </div>
        </div>
      );
    case 'homeworks-student homework setItemPointHomeworkChecked':
      return (
        <div className="notification-item-content">
          <div className="left-block">
            <span className="icon">
              <img src={exumIcon} alt="icon" />
            </span>
          </div>
          <div className="right-block">
            <span className="text-row">
              {`${t('Student')} ${studentName} ${t('marked the point')} `}
              <a href="#" onClick={e => handleNavigationItem(e, item)} onMouseDown={e => handleMouseDown(e, item)}>
                {t('student noted homework') + ' ( ' + item.name + ' ) '}
              </a>
              {` ${t('homework how its done')} `}
              {' ' + t('by subject') + ' '}
              {t(subjectsObjKey[item.subject])}.
            </span>
            <span className="icon">
              <img src={item.viewed ? checksNotIcon : checksIcon} alt="icon" />
            </span>
            <span className="time-row">{formatDate(item.time)}</span>
          </div>
        </div>
      );
    case 'homeworks-student homeworks-points setItemPointHomeworkFile':
      return (
        <div className="notification-item-content">
          <div className="left-block">
            <span className="icon">
              <img src={exumIcon} alt="icon" />
            </span>
          </div>
          <div className="right-block">
            <span className="text-row">
              {t('The student added a file to') + ' '}
              <a href="#" onClick={e => handleNavigationItem(e, item)} onMouseDown={e => handleMouseDown(e, item)}>
                {'( ' + t('point') + ': ' + item.titles[item.point - 1] + ' )'}
              </a>
              {` ${t('In')} `}
              <a href="#" onClick={e => handleNavigationItem(e, item)} onMouseDown={e => handleMouseDown(e, item)}>
                {t('In homework') + ' ( ' + item.name + ' ) '}
              </a>
              {' ' + t('by subject') + ' '}
              {t(subjectsObjKey[item.subject])}.
            </span>
            <span className="icon">
              <img src={item.viewed ? checksNotIcon : checksIcon} alt="icon" />
            </span>
            <span className="time-row">{formatDate(item.time)}</span>
          </div>
        </div>
      );
    case 'homeworks-student homework setItemPointHomeworkFile':
      return (
        <div className="notification-item-content">
          <div className="left-block">
            <span className="icon">
              <img src={exumIcon} alt="icon" />
            </span>
          </div>
          <div className="right-block">
            <span className="text-row">
              {t('The student added a file to') + ' '}
              <a href="#" onClick={e => handleNavigationItem(e, item)} onMouseDown={e => handleMouseDown(e, item)}>
                {t('to homework') + ' ( ' + item.name + ' ) '}
              </a>
              {t('by subject') + ' '}
              {t(subjectsObjKey[item.subject])}.
            </span>
            <span className="icon">
              <img src={item.viewed ? checksNotIcon : checksIcon} alt="icon" />
            </span>
            <span className="time-row">{formatDate(item.time)}</span>
          </div>
        </div>
      );

    case 'examCompleted':
      return getMessage(
        `${t('Student')} ${studentName} ${t('sendedCompletedExam')}`,
        'exam name',
        language === 'ua' ? item.subject.name : item.subject.ruName,
      );

    case 'examChecked':
      return getMessage(
        `${t('Teacher')} ${teacherName} ${t('examCheckedByTeacher')}`,
        'exam name',
        language === 'ua' ? item.subject.name : item.subject.ruName,
      );
    default:
      return null;
  }
};
